(ns hai.library.connections.routes
  "Connection routes"
  (:require
   [hai.admin-ui.api-keys :as api-keys]
   [hai.library.connections.create :as create]
   [hai.library.connections.linear-preview :as linear-preview]
   [hai.library.connections.preview :as preview]
   [hai.library.connections.table :as table]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.layout :as layout]
   [hai.web-app.routing :as routing]
   [hai.web-app.util.params :as params-util]))

(defn- api-key-page [view-fn]
  (fn [_]
    [layout/page
     [layout/breadcrumbs]
     [layout/heading]
     [layout/content
      [view-fn]]]))

(defn routes
  []
  [["/connections"
    {::routing/window-title "Connections"
     :icon icons/outlined-electrical_services}
    [""
     {:name        :connections/table
      :label       "Connections"
      :breadcrumbs ["Connections"]
      :view        table/page}]
    ["/preview/{connection/uuid}"
     {:name :connections/preview
      :breadcrumbs [:connections/table]
      :label "Preview Data"
      ::routing/window-title "Connection Preview"
      :view preview/page}]
    ["/linear-preview/{connection/uuid}"
     {:name :connections/linear-preview
      :breadcrumbs [:connections/table]
      :label "Linear Preview"
      ::routing/window-title "Linear Preview"
      :view linear-preview/page}]
    [""
     {:breadcrumbs [:connections/table]
      :label "New Connection"}
     ["/new"
      {:name :connections/new
       ::routing/window-title "New Connection"
       :view create/page}]
     ["/create/{source/type}"
      {:name :connections/create
       :view create/page}]
     ["/oauth/callback/{source/type}"
      {:name :connections/oauth-callback
       :view create/page
       :controllers [{:parameters {:path [:source/type]}
                      :start (fn [{params :path}]
                               (let [source-type (:source/type params)
                                     authorization-token (params-util/query-param :authorization_voucher)
                                     metadata (params-util/query-param :metadata)]
                                 (>e [:oauth/handle-callback {:source-type source-type
                                                              :authorization-token authorization-token
                                                              :metadata metadata}])))}]}]]
    ["/api-keys"
     {:breadcrumbs [:connections/table]
      :label "API Keys"
      ::routing/window-title "API Keys"}
     ["/new"
      {:name :connections/new-api-key
       ::routing/window-title "New API Key"
       :view (api-key-page api-keys/new-api-key-ui)}]
     ["/show"
      {:name :connections/show-new-key
       ::routing/window-title "Your API Key"
       :view (api-key-page api-keys/show-new-key-ui)}]]]])
